import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

export const useWorkspaceInfoBannerStyles = makeStyles({
  banner: {
    display: "flex",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[3],
    background: projectIqTokens.tealSoft,
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.accent[700],
  },
  icon: {
    color: designTokens.accent[700],
    fontSize: designTokens.fontSize.lg,
    flexShrink: 0,
  },
  text: {
    fontSize: designTokens.fontSize.xs,
  },
});
